import { useState } from "react";
import { supabase } from "../lib/SupabaseClient";
import { useNavigate, Link } from "react-router-dom";

export default function ResetPassword() {
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        setMessage(null);

        if (password !== confirm) {
            setError("❌ Passwords do not match.");
            setBusy(false);
            return;
        }

        const { error } = await supabase.auth.updateUser({ password });

        if (error) {
            setError(error.message);
        } else {
            setMessage("✅ Password updated successfully! Redirecting to login...");
            setTimeout(() => nav("/login"), 2000);
        }

        setBusy(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-900 text-center">
                    Reset Password
                </h2>
                <p className="mt-2 text-sm text-gray-600 text-center">
                    Enter your new password below to secure your account.
                </p>

                {error && (
                    <div className="mt-4 rounded bg-red-50 p-3 text-red-700 text-sm">
                        {error}
                    </div>
                )}
                {message && (
                    <div className="mt-4 rounded bg-green-50 p-3 text-green-700 text-sm">
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="New password"
                        required
                        className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                    />
                    <input
                        type="password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        placeholder="Confirm new password"
                        required
                        className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                    />

                    <button
                        type="submit"
                        disabled={busy}
                        className="w-full bg-indigo-600 text-white py-2 rounded-lg font-medium hover:bg-indigo-700 transition disabled:opacity-60"
                    >
                        {busy ? "Updating..." : "Update Password"}
                    </button>
                </form>

                {/* Back to login link */}
                <p className="mt-6 text-center text-sm text-gray-600">
                    Changed your mind?{" "}
                    <Link to="/login" className="text-indigo-600 hover:underline">
                        Go back to Login
                    </Link>
                </p>
            </div>
        </div>
    );
}
